const sharedProps = {
	type: 'select-optional',
	unit: {
		da: 'stk',
		kl: '-nik amerlassusillit'
	},
	isRepeatableAfterXRounds: 0,
	statId: 'purchase-selected',
	modifiesStatId: 'purchase-base',
	statId2: 'supplier-selected',
	modifiesStatId2: 'supplier-base'
};

const supplierActionOptions = [
	{
		id: 'tshirt-supplier-a',
		title: {
			da: 'Skift t-shirt-leverandør',
			kl: 'Tujuuluaqqanik pisiffigisartagarsi taarsersiuk',
		},
		title2: {
			da: 'Skift antal bestilte t-shirts',
			kl: 'Tujuuluaqqat inniminnikkassi amerlassusaat allanngortissiuk',
		},
		description: {
			da: 'T-shirts af medium kvalitet.',
			kl: 'Tujuuluaqqaq naammaannartumik pitsaassusillit.',
		},
		...sharedProps,
		minVal: 200,
		maxVal: 1000,
		stepSize: 50,
		effects: [
			{
				type: 'change-stat',
				statId: 'supplier-selected',
				statValue: 'tshirt-supplier-a'
			},
			{
				type: 'change-stat',
				statId: 'quality-score-base',
				statValue: 2
			},
			{
				type: 'change-stat',
				statId: 'purchase-price',
				statValue: 25
			},
			{
				type: 'change-stat-selected',
				statId: 'purchase-selected',
				modifiesStatId: 'purchase-base'
			}
		]
	},
	{
		id: 'tshirt-supplier-b',
		title: {
			da: 'Skift t-shirt-leverandør',
			kl: 'Tujuuluaqqanik pisiffigisartagarsi taarsersiuk',
		},
		title2: {
			da: 'Skift antal bestilte t-shirts',
			kl: 'Tujuuluaqqat inniminnikkassi amerlassusaat allanngortissiuk',
		},
		description: {
			da: 'De bedste t-shirts, I kender til.',
			kl: 'Ilisimasassinni tujuuluaqqat pitsaanerpaat.',
		},
		...sharedProps,
		minVal: 200,
		maxVal: 1500,
		stepSize: 100,
		effects: [
			{
				type: 'change-stat',
				statId: 'supplier-selected',
				statValue: 'tshirt-supplier-b'
			},
			{
				type: 'change-stat',
				statId: 'quality-score-base',
				statValue: 4
			},
			{
				type: 'change-stat',
				statId: 'purchase-price',
				statValue: 50
			},
			{
				type: 'change-stat-selected',
				statId: 'purchase-selected',
				modifiesStatId: 'purchase-base'
			}
		]
	},
	{
		id: 'tshirt-supplier-c',
		title: {
			da: 'Skift t-shirt-leverandør',
			kl: 'Tujuuluaqqanik pisiffigisartagarsi taarsersiuk',
		},
		title2: {
			da: 'Skift antal bestilte t-shirts',
			kl: 'Tujuuluaqqat inniminnikkassi amerlassusaat allanngortissiuk',
		},
		description: {
			da: 'De bedste t-shirts i kender til, til en bedre pris, men større minimumsordre.',
			kl: 'Ilisimasassinni tujuuluaqqat pitsaanerpaat.',
		},
		...sharedProps,
		stepSize: 350,
		minVal: 1500,
		maxVal: 5000,
		effects: [
			{
				type: 'change-stat',
				statId: 'supplier-selected',
				statValue: 'tshirt-supplier-c'
			},
			{
				type: 'change-stat',
				statId: 'quality-score-base',
				statValue: 4
			},
			{
				type: 'change-stat',
				statId: 'purchase-price',
				statValue: 35
			},
			{
				type: 'change-stat-selected',
				statId: 'purchase-selected',
				modifiesStatId: 'purchase-base'
			}
		]
	},
	{
		id: 'tshirt-supplier-d',
		title: {
			da: 'Skift t-shirt-leverandør',
			kl: 'Tujuuluaqqanik pisiffigisartagarsi taarsersiuk',
		},
		title2: {
			da: 'Skift antal bestilte t-shirts',
			kl: 'Tujuuluaqqat inniminnikkassi amerlassusaat allanngortissiuk',
		},
		description: {
			da: 'De billigste.',
			kl: 'Akikinnerpaat.',
		},
		...sharedProps,
		minVal: 150,
		maxVal: 1000,
		stepSize: 50,
		effects: [
			{
				type: 'change-stat',
				statId: 'supplier-selected',
				statValue: 'tshirt-supplier-d'
			},
			{
				type: 'change-stat',
				statId: 'quality-score-base',
				statValue: 1
			},
			{
				type: 'change-stat',
				statId: 'purchase-price',
				statValue: 15
			},
			{
				type: 'change-stat-selected',
				statId: 'purchase-selected',
				modifiesStatId: 'purchase-base'
			}
		]
	},
];

export default supplierActionOptions;